const baseUrlMain = "/v1/admin";
const baseUrl = "/v1/admin/dashboard";

export const apiUrls = {
  chartMap: `${baseUrl}`,
  getChartUsers: `${baseUrlMain}/dashboard-user-list`,
  downloadExcel: `${baseUrlMain}/dashboard-user-list-export`,
};
